<template>
  <div class="fansChange">
    <el-card class="card1" shadow="never">
      <!-- 标题区域 -->
      <div class="top clearfix">
        <div class="fl">
          <img
            src="../../assets/images/newIcon/vipanalysis_fanschange_icon@2x.png"
            alt=""
          />
          <span></span
          ><b style="display: inline-block; transform: translate(4px, 2px);font-weight:500;"
            >粉丝转化</b
          >
        </div>
        <!-- 右侧区域 -->
        <div class="fr">
          <p>
            <img
              src="../../assets/images/newIcon/ss_shaixuan_icon.png"
              alt=""
            />
            <el-select
              style="width: 100px"
              v-model="options1.value"
              placeholder="请选择"
              class="my-select"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              style="width: 100px"
              v-model="def2"
              placeholder="请选择"
              class="my-select2"
            >
              <el-option
                v-for="item in options2"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
                 <el-date-picker
                  v-if="isshow"
                  v-model="value1"
                  class="rqc"
                  ref="int"
                  type="date"
                >
                </el-date-picker>
            </el-select>
          </p>
        </div>
      </div>
      <!-- 数字区域 -->
      <ul>
        <li>
          <p>
            <span class="blueBar"></span>
            <span class="txtColor fz14">粉丝UV</span>
          </p>
          <p class="fz29" style="font-weight:bold;">199</p>
        </li>
        <li>
          <p>
            <span class="blueBar"></span>
            <span class="txtColor fz14">粉丝下单人数</span>
          </p>
          <p class="fz29" style="font-weight:bold;">199</p>
        </li>
        <li>
          <p>
            <span class="blueBar"></span>
            <span class="txtColor fz14">粉丝下单订单数</span>
          </p>
          <p class="fz29" style="font-weight:bold;">199</p>
        </li>
      </ul>
    </el-card>
    <!-- 表格样式 -->
    <el-table :header-cell-style="{background:'#EEEEEE',color:'#606266'}" class="my-table" :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="日期" width="180"> </el-table-column>
      <el-table-column prop="name" label="粉丝UV" width="180">
      </el-table-column>
      <el-table-column prop="m1" label="粉丝下单人数"> </el-table-column>
      <el-table-column prop="m2" label="粉丝下单订单数"> </el-table-column>
      <el-table-column prop="m3" label="粉丝图文下单率"> </el-table-column>
      <el-table-column prop="m4" label="粉丝下单金额（元）"> </el-table-column>
    </el-table>
    <!-- 分页 -->
    <!--  @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      分页插件的数据 -->
    <el-pagination
      class="my-page"
      background
      :page-sizes="[10, 20, 30, 40]"
      :page-size="10"
      layout="prev,pager,next,sizes,jumper"
      :total="70"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
        //下拉表单模拟数据
        isshow:false,
        value1:null,
        def2:'本周',
      options1: [{ name: "积木云客服号" }],
      options2: [{ name: "本周" },{ name: "本月" },{ name: "近90天" },{ name: "近半年" },{ name: "自定义" },],
      //表格模拟数据
      tableData: [
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
        {
          date: "2018.03.05",
          name: "4,32%",
          m1: "4,323",
          m2: "100",
          m3: "0.01%",
          m4: "100",
        },
      ],
    };
  },
    watch: {
    value1() {
      if (this.value1) {
        this.isshow = false;
      }
    },
    def2() {
      if (this.def2 == "自定义") {
        this.isshow = true;
        this.$nextTick(() => {
          this.$refs.int.$children[0].focus();
        });
      } else {
        this.isshow = false;
      }
    },
  },
};
</script>
<style lang="less">
.fansChange {
  padding: 20px;
  //  card样式
  .card1 {
    //   标题样式
    .top {
      margin-top: -5px;
      .fl {
        float: left;
        font-size: 16px;
        display: flex;
        b {
          margin-left: 6px;
        }
        img {
          width: 24px;
        }
      }
      .fr {
        float: right;
        color: #999999;
        font-size: 12px;
        p {
          img {
            width: 16px;
            vertical-align: middle;
            //   margin-right: 10px;
          }
        }
        .my-select {
          margin-left: 10px;
          .el-input {
            width: 130px;
          }
        }
        .my-select2 {
          margin-left: 40px;
        }
      }
    }
    //数字样式
    ul {
      display: flex;
      margin-top: 30px;
      margin-left: 30px;
      li {
        &:nth-child(1) {
          margin-right: 80px;
        }
        &:nth-child(2) {
          padding-left: 100px;
          padding-right: 100px;
          border-left: 2px solid #e6e6e6;
          border-right: 2px solid #e6e6e6;
        }
        &:nth-child(3) {
          margin-left: 80px;
        }
      }
    }
  }
  //表格样式
  .my-table {
    margin-top: 30px;
    .el-table__row{
        height: 53px;
    }
    .cell{
        text-align: center;
        font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
    }
  }
  //分页样式
  .my-page {
    margin-top: 15px;
    .el-pager li {
      background-color: #fff;
    }
    .btn-prev {
      background-color: #fff;
    }
    .btn-next {
      background-color: #fff;
    }
    .el-pagination__jump{
        margin-left: 10px;
    }
  }
  //公共样式区
  .blueBar {
    display: inline-block;
    width: 4px;
    height: 12px;
    background: #327eff;
    border-radius: 2px;
    transform: translate(0px, 1px);
  }
  .txtColor {
    color: #7e858c;
    margin-left: 5px;
  }
  .fz14 {
    font-size: 14px;
  }
  .fz29 {
    margin-left: 7px;
    margin-top: 8px;
    font-size: 29px;
  }
}
</style>